<template>
  <div class="wdb100">
    <el-select
      v-model="internalValue"
      ref="remoteSelect"
      clearable
      filterable
      remote
      :remote-method="getRemoteData"
      @clear="getRemoteData('')"
      @focus="getRemoteData('')"
      :loading="loading"
      :placeholder="placeholder"
      class="wdb100"
      @change="handleChange"
    >
      <el-option
        v-for="(item, index) in dataList"
        :key="`client-code-remote-${index}-${item.clientCode}`"
        :label="item.clientCode"
        :value="item.clientCode"
      >
        <div>{{ item.clientCode }}-{{ item.companyName }}</div>
      </el-option>
    </el-select>

    <!-- 自动填充client code关联信息 - 弹窗 -->
    <Autofill ref="autofillRef" :showItems="showItems" @selectedInfo="selectedInfo"></Autofill>
  </div>
</template>

<script>
import Autofill from "./modal/Autofill";
export default {
  props: {
    // 接收父级 v-model 的值
    value: {
      type: String,
      default: "",
    },
    // 需要显示的自动填充项
    showItems: {
      type: Array,
      default: () => [],
    },
    // 显示的占位符
    placeholder: {
      type: String,
      default: "Please Select",
    },
  },
  components: { Autofill },
  data() {
    return {
      loading: false,
      dataList: [],
    };
  },
  computed: {
    // 联动父级 v-model
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 远程搜索请求，后端默认返回前20条数据
    getRemoteData(query) {
      this.loading = true;
      this.$http
        .get("/admin/clientCodeInfoMa/getList", {
          params: { keywords: query },
        })
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .catch(err => {
          this.dataList = [];
        })
        .finally(() => {
          this.loading = false;
          // 解决首次搜索结果为[]时，下拉框空提示(No data)不出现的bug
          if (this.dataList.length === 0) {
            const selectComponent = this.$refs.remoteSelect;
            if (selectComponent) {
              // 欺骗组件：让它认为有搜索词，从而激活 No data 面板的渲染
              selectComponent.query = query || " ";
              // 强行把下拉面板撑开
              selectComponent.visible = true;
            }
          }
        });
    },
    // 选中值变化时
    handleChange(val) {
      // 如果没有需要自动填充项，就不显示Autofill弹窗
      if (!this.showItems || this.showItems.length == 0) return;
      const selectedItem = this.dataList.find(item => item.clientCode == val);
      if (selectedItem) {
        this.$refs.autofillRef.init(selectedItem);
      }
    },
    // 子组件Autofill弹窗提交时触发
    selectedInfo(data) {
      this.$emit("change-item", data);
    },
  },
};
</script>
